export default __webpack_public_path__ + "static/media/clip_icon.83a2c6b2.svg";